import './styles/App.scss';
import ToDos from './views/todos/todos'
import RouterConfig from './routers/index'

function App() {
  return (
    <div className="App">
      <RouterConfig></RouterConfig>
      <ToDos></ToDos>
    </div>
  );
}

export default App;
